/** Shared animation constants for dictation bubbles (web + widget). */

const EASE_OUT_QUINT = [0.23, 1, 0.32, 1] as const;
const TRANSITION = { duration: 0.2, ease: EASE_OUT_QUINT } as const;
const HIDDEN = { opacity: 0, y: 8 } as const;
const VISIBLE = { opacity: 1, y: 0 } as const;

/** Animate in on mount, stay visible on exit. */
export const bubbleEnterAnimation = {
  initial: HIDDEN,
  animate: VISIBLE,
  exit: VISIBLE,
  transition: TRANSITION,
} as const;

/** No animation on mount, animate out on exit. */
export const bubbleExitAnimation = {
  initial: false,
  animate: VISIBLE,
  exit: HIDDEN,
  transition: TRANSITION,
} as const;

/** Animate in on mount and out on exit. */
export const bubbleEnterExitAnimation = {
  initial: HIDDEN,
  animate: VISIBLE,
  exit: HIDDEN,
  transition: TRANSITION,
} as const;

/** Duration before auto-dismissing error/info messages. */
export const MESSAGE_DISPLAY_DURATION_MS = 3000;
